import { AnnualChangeData } from "@models/annual-statements/annualChangeData";
import { DocumentBase } from "@models/documents/document-base";
import { AnnualStatementStatus } from "./annual-statement-enums";

export class AnnualStatement extends DocumentBase {
  annualStatementStatus: AnnualStatementStatus;
  isPaid: boolean
  paymentAmount: number; // do not use this on UI;
  override changes: AnnualChangeData[];
  paymentDeadline: string | null;
  reviewDate: string | null;

  constructor(data: Partial<AnnualStatement> = {}) {
    super(data);
    this.annualStatementStatus = data.annualStatementStatus ?? AnnualStatementStatus.ReadyToPrepare;
    this.changes = data.changes?.map(change => new AnnualChangeData(change)) ?? [];
    this.isPaid = data.isPaid ?? false;
    this.paymentAmount = data.paymentAmount ?? 0;
    this.paymentDeadline = data.paymentDeadline ?? null;
    this.reviewDate = data.reviewDate ?? null;
  }

  static isImportedDocument(annualStatement: Partial<AnnualStatement>): boolean {
    return annualStatement.type == "c:480:Imported";
  }
}
